import z from "zod";
import { FILE_COLLECTION_TABLES, isFileCollectionKey } from "../../../types/files";

/**
 * The address of one link between a file and a parent — the row an unlink removes.
 *
 * Table and column are both pinned against the registry, for the reason
 * `getForeignFilesSchema` gives: the column decides what the delete matches on.
 */
export const deleteForeignFileSchema = z
	.object({
		tableName: z.enum(FILE_COLLECTION_TABLES),
		key: z.string(),
		identifier: z.uuid(),
		fileId: z.uuid(),
	})
	.refine(({ tableName, key }) => isFileCollectionKey(tableName, key), {
		message: "key is not a foreign key column of this collection",
		path: ["key"],
	});
